
import React, { useState } from 'react';


import icone_local_protegido from '../../../../../../assets/imgs/icone_local_protegido.png';

import icone_local_alarme from '../../../../../../assets/imgs/icone_local_alarme.png';
import icone_offline from '../../../../../../assets/imgs/icone_offline.png';

import icone_local_desprotegido from '../../../../../../assets/imgs/icone_local_desprotegido.png';
import Grid from '@material-ui/core/Grid';
import { Switch, FormControlLabel, Typography, Box, Paper, Tooltip } from '@mui/material';
import Cookies from 'js-cookie';
import SensorsIcon from '@mui/icons-material/Sensors';
import SecurityIcon from '@mui/icons-material/Security';
import SignalCellularConnectedNoInternet4BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet4Bar';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';


export default function CabecalhoInformacoes(props) {
    const { pgmsArmadas, pgmsDesarmadas, pgmsOfflines, pgmsAlarmadas, filtrar, useNativeCall, setUseNativeCall, sipStatus } = props;

    const [darkMode] = React.useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    const StatusCard = ({ label, count, color, icon, onClick, type }) => {
        const isAlarm = type === 'alarme' && count > 0;
        return (
            <Grid item xs={6} sm={6} md={3} lg={2}>
                <Paper
                    elevation={0}
                    onClick={onClick}
                    sx={{
                        background: darkMode ? '#000000' : 'rgba(255, 255, 255, 0.8)',
                        backdropFilter: 'blur(12px)',
                        border: `1px solid ${darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0,0,0,0.05)'}`,
                        borderRadius: '16px',
                        p: 2,
                        cursor: 'pointer',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        position: 'relative',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100px',
                        '&:hover': {
                            transform: 'translateY(-4px)',
                            border: `1px solid ${color}`,
                            boxShadow: `0 8px 24px -12px ${color}80`,
                            '& .glow-bg': { opacity: 0.1 }
                        },
                        ...(isAlarm && {
                            animation: 'pulse-red 2s infinite ease-in-out',
                            border: '1px solid #ef4444'
                        })
                    }}
                >
                    <div className="glow-bg" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: color, opacity: 0, transition: 'opacity 0.3s' }} />
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, zIndex: 1 }}>
                        <Box sx={{ color: color, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 1, borderRadius: '12px', background: `${color}15`, boxShadow: `inset 0 0 12px ${color}20` }}>
                            {icon}
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: '1.8rem', fontWeight: 900, color: darkMode ? '#f8fafc' : '#0f172a', lineHeight: 1, fontFamily: 'monospace' }}>
                                {count}
                            </Typography>
                            <Typography sx={{ fontSize: '0.65rem', fontWeight: 800, color: darkMode ? '#94a3b8' : '#64748b', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                {label}
                            </Typography>
                        </Box>
                    </Box>
                    <style dangerouslySetInnerHTML={{ __html: `
                        @keyframes pulse-red {
                            0% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.4); border-color: rgba(239, 68, 68, 0.5); }
                            70% { box-shadow: 0 0 0 15px rgba(239, 68, 68, 0); border-color: rgba(239, 68, 68, 1); }
                            100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); border-color: rgba(239, 68, 68, 0.5); }
                        }
                    `}} />
                </Paper>
            </Grid>
        );
    };

    return (
        <Grid container spacing={2} sx={{ p: 2, mb: 2 }}>
            <StatusCard 
                label="Protegidos" 
                count={pgmsArmadas} 
                color="#10b981" 
                icon={<SecurityIcon fontSize="small" />} 
                onClick={() => filtrar("protegido")}
                type="protegido"
            />
            <StatusCard 
                label="Desarmados" 
                count={pgmsDesarmadas} 
                color="#f59e0b" 
                icon={<SensorsIcon fontSize="small" />} 
                onClick={() => filtrar("inseguro")}
                type="inseguro"
            />
            <StatusCard 
                label="Desconectados" 
                count={pgmsOfflines} 
                color="#8b5cf6" 
                icon={<SignalCellularConnectedNoInternet4BarIcon fontSize="small" />} 
                onClick={() => filtrar("offline")}
                type="offline"
            />
            <StatusCard 
                label="Em Alarme" 
                count={pgmsAlarmadas} 
                color="#ef4444" 
                icon={<NotificationsActiveIcon fontSize="small" />} 
                onClick={() => filtrar("alarme")}
                type="alarme"
            />

            <Grid item xs={12} sm={12} md={12} lg={4}>
                <Paper
                    elevation={0}
                    sx={{
                        background: darkMode ? '#000000' : 'rgba(72, 209, 204, 0.05)',
                        backdropFilter: 'blur(12px)',
                        border: `1px solid ${darkMode ? 'rgba(72, 209, 204, 0.3)' : 'rgba(72, 209, 204, 0.2)'}`,
                        borderRadius: '16px',
                        p: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100px',
                        transition: 'all 0.3s',
                        '&:hover': { background: darkMode ? 'rgba(72, 209, 204, 0.15)' : 'rgba(72, 209, 204, 0.1)' }
                    }}
                >
                    <FormControlLabel
                        control={
                            <Switch
                                checked={useNativeCall}
                                onChange={(e) => setUseNativeCall(e.target.checked)}
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': { color: '#48D1CC' },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#48D1CC' }
                                }}
                            />
                        }
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography sx={{ color: darkMode ? '#f8fafc' : '#0f172a', fontWeight: 800, fontSize: '0.85rem', letterSpacing: '0.5px' }}>
                                        MODO SIP NATIVO
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                        <div style={{
                                            width: 8, height: 8, borderRadius: '50%',
                                            backgroundColor: sipStatus === 'Registered' ? '#10b981' : (sipStatus?.includes('Error') ? '#ef4444' : '#f59e0b'),
                                            boxShadow: sipStatus === 'Registered' ? '0 0 8px #10b981' : 'none'
                                        }} />
                                        <Typography sx={{ fontSize: '0.7rem', color: darkMode ? '#94a3b8' : '#64748b', fontWeight: 700, fontFamily: 'monospace' }}>
                                            {sipStatus || 'STANDBY'}
                                        </Typography>
                                    </Box>
                                </Box>
                                <SettingsInputAntennaIcon sx={{ color: '#48D1CC', opacity: 0.8 }} />
                            </Box>
                        }
                    />
                </Paper>
            </Grid>
        </Grid>
    );
}

